const routes = [
    {
        path: "/relative/grades",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "relativegrade_index"
        },
        component_full_path: "relativeGrades/pages/Index"
    }
];

export default routes;
